var FormSendEx=function(el) {
    this.initialize(el);
    return this;
};

var FormIds=0;
var FormSingltones={};
function IsSafariBrowser()
{
    var VendorName=window.navigator.vendor;
    return ((VendorName.indexOf('Apple') > -1) &&
        (window.navigator.userAgent.indexOf('Safari') > -1));
}

$.extend(FormSendEx.prototype,{
    id:null,
    el:null,
    $el:null,
    appends:[],
    initialize:function(el) {
        this.el=el;
        this.$el=$(this.el);
        this.id="Form_"+(++FormIds);
        FormSingltones[this.id]=this;
        this.$el.attr("data-id",this.id);
        this.$el.attr("data-form-ex",true);
    },
    addFile:function(name,value) {
        console.log("added ",name);
        this.appends.push({name:name,value:value});
    },
    send:function(callback) {
        var formData = null;
        if (IsSafariBrowser())
        {
            formData= new FormData();
            var FormElementCollection=this.el.elements;
            //console.log('namedItem='+FormElementCollection.namedItem('KEY'));
            var JQEle,EleType;
            for (ele=0; (ele < FormElementCollection.length); ele++)
            {
                JQEle=$(FormElementCollection.item(ele));
                EleType=JQEle.attr('type');

                // https://github.com/jimmywarting/FormData/blob/master/FormData.js
                if ((! JQEle.attr('name')) ||
                    (((EleType == 'checkbox') || (EleType == 'radio')) &&
                        (! JQEle.prop('checked'))))
                    continue;
                formData.append(JQEle.attr('name'),JQEle[0].value);
            }
        }
        else
        {
            formData = new FormData(this.el);
        }

        $.each(this.appends,function(key,value){
            formData.append(value.name,value.value);
            console.log("append",value.name);
        });

        var url=this.$el.attr("action");
        $.ajax({
            url:url,
            data:formData,
            processData:false,
            contentType: false,
            method: 'POST',
            type: 'POST',
            cache: false,
            dataType: "multipart/form-data",
            beforeSend:function() {
                $.ajax({
                    async:false,
                    url:'/closeconnectionfix'
                });
            },
            success: function(data, textStatus, jqXHR) {
                console.log("success",data,textStatus);
                if(data && typeof data.success!=="undefined") {
                    if(data.success) {
                        window.location=(data.url.substr(0,1)==="/")?data.url:"/"+data.url;
                    }else{
                        notify(data.message, '','danger');
                    }
                    callback(data.success);
                }else{
                    callback(false);
                }

            },
            error: function(data, textStatus, jqXHR) {
                console.log(data.responseText);
                var data = JSON.parse(data.responseText);
                if(data && typeof data.success!=="undefined") {
                    if(data.success) {
                        window.location=(data.url.substr(0,1)==="/")?data.url:"/"+data.url;
                    }else{
                        notify(data.message, '','danger');
                    }
                    callback(data.success);
                }else{
                    notify(LANGUAGE['ajax.save.error'], '','danger');
                    callback(false);
                }
            }
        });
    }
});


function AddToClosestForm(from,name,val) {
    var dataId=(from && $(from).closest("form")) ? $(from).closest("form").attr("data-id") : null;
    if(FormSingltones[dataId]) {
        FormSingltones[dataId].addFile(name,val);
    }
}

function SendClosestForm(from,callback) {
    var dataId=(from && $(from).closest("form")) ? $(from).closest("form").attr("data-id") : null;
    if(FormSingltones[dataId]) {
        FormSingltones[dataId].send(callback);
    }
}

function GetClosestForm(from) {
    var dataId=(from && $(from).closest("form")) ? $(from).closest("form").attr("data-id") : null;
    return FormSingltones[dataId]?FormSingltones[dataId]:null;
}



$(function(){
    $("body").on("click",".ajaxformsend, .fjs",function(e){
        $(this).prop("disabled",true);
        $(this).closest("form").submit();
        return false;
    });

    $("body").on("change dp.change","input, textarea, select",function(e) {
        $(this).closest("form").attr("data-dirty","true");
    });

    $("body").on("click",".backbutton, .fbb",function(e){
        var form=$(this).closest("form");
        var isDirty=form.attr("data-dirty")==="true";
        if(isDirty) {
            $("#dismisModal").modal('show');
            $("#dismisModal").find(".btn-danger").attr("href",$(this).attr("href"));
        }
        return !isDirty;
    });


    $("body").on("click",".ajaxformsend-ex, .fjs-ex",function(e){
        $(this).prop("disabled",true);
        var self=$(this);
        SendClosestForm(this,function(success){
            if(!success) {
                self.prop("disabled",false);
            }
        });

        return false;
    });

    $("form").each(function(i,value) {
        value.formex=new FormSendEx(value);
    });

    $("body").on("click","[data-my-toggle=\"modal\"]",function() {
        $($(this).attr("href")).modal('show');
        return false;
    });
});